import clsx from 'clsx';
import { createElement, FC, forwardRef, FunctionComponent, HTMLProps, PropsWithChildren, ReactHTML } from 'react';
import classes from './option-group.module.scss';

export type OptionGroupProps<P extends object = HTMLProps<HTMLDivElement>>
  = PropsWithChildren & {
  /**
   * Custom classname
   */
    className?: string;

    /**
   * Customize render element
   */
    as?: FunctionComponent<P> | keyof ReactHTML;
  };

export const OptionGroup: FC<OptionGroupProps> = forwardRef<
  HTMLDivElement,
  OptionGroupProps
>(({
  className,
  as = 'div',
  ...props
}, ref) => {
  return createElement(
    as as keyof ReactHTML,
    {
      ...props,
      ref,
      className: clsx(classes.root, className, 'option-group-component'),
    },
  );
});
